import {
    imageClassName,
    pxToRem,
    videoPlayerClassName,
    boxClassName,
    imageOverlayClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

import { PRODUCT_GALLERY_SIZE } from './ProductGallery.style';

const MOBILE_VIDEO_SIZE = pxToRem(378);
const DESKTOP_VIDEO_SIZE = pxToRem(PRODUCT_GALLERY_SIZE);

export const VideoSlideWrapper: StyleRule = ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: MOBILE_VIDEO_SIZE,
    backgroundColor: theme.siteVariables.colors.primitive.black,
    [theme.screen.tablet]: {
        height: DESKTOP_VIDEO_SIZE,
    },
});

export const VideoContainer: StyleRule = ({ theme }) => ({
    width: '100vw',
    [`& .${imageClassName}`]: {
        width: '100%',
        height: '100%',
        background: 'none',
    },
    [`& .${svgIconClassName} svg`]: {
        height: pxToRem(34),
        width: pxToRem(34),
    },
    [theme.screen.min.tablet]: {
        maxWidth: DESKTOP_VIDEO_SIZE,
        marginLeft: 'auto',
        marginRight: 0,
        [`& .${imageClassName}`]: {
            maxWidth: DESKTOP_VIDEO_SIZE,
            height: '100%',
            ['& .' + imageOverlayClassName]: {
                backgroundColor: 'transparent',
            },
        },
        [`& .${svgIconClassName}`]: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: pxToRem(80),
            width: pxToRem(80),
            transform: 'translate(-50%, -50%)',
            borderRadius: '100%',
            background: 'rgba(242, 241, 240, 0.5)',

            '&:hover': {
                background: theme.siteVariables.colors.white['FFF'],
            },

            '& svg': {
                '& :last-child': {
                    fill: theme.siteVariables.colors.charcoal['250'],
                },
            },
        },
    },
});

export const AspectRatioBox: StyleRule = () => ({
    paddingTop: '56.25%',
    position: 'relative',
    [`& .${videoPlayerClassName}`]: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        [`& .${boxClassName}`]: {
            '&:hover': {
                '& svg': {
                    transform: `translate(-50%, -50%) scale(1)`,
                },
            },
        },
    },
});
